<template>
	<div>
    <search-list
      @search="search"
    ></search-list>

		<table-list
			:columns="columns"
			:data="data"
			:current="current"
			:total="total"
			:loading="loading"
			@change-page="changePage"
		></table-list>
    <cancel-group
    @search="getSearchData"
    :fid="fid"
    :n="cancelGroup"
    ></cancel-group>
	</div>
</template>

<script>
import SearchList from './components/SearchList'
import TableList from 'components/TableList/index';
import CancelGroup from './components/CancelGroup'
import { getDate } from '@/utils/tool'
import { confirmOrCancelParticipate,getCollageGroupList } from 'api/groupmanage'
export default {
  components:{
		TableList,
    SearchList,
    CancelGroup
	},
	data(){
		return{
			loading:false,
			total:0,
			current:1,
      cancelGroup:0,
      fid:'',
			data:[],
			columns:[
        {
          title:'拼团状态',
          key: 'participateStatus',
          width: 130,
          align: 'center',
          render:(h,params)=>{
						return h('span', {}, params.row.participateStatus === 1 ? '拼团中' : params.row.participateStatus === 2 ? '拼团成功' : params.row.participateStatus === 3 ? '已取消' : '--')
					}
        },
        {
          title: ' '
        },
        {
          title: ' '
        },
				{
          title:'项目',
          key: 'projectName',
          width: 180,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'客户姓名',
          key: 'nickName',
          width: 130,
          align: 'center',
        },
        {
          title: ' '
        },
        {
          title:'电话',
          key: 'mobile',
          width: 180,
          align: 'center',
        },
        {
          title: ' '
        },
				{
					title:'拼团类型',
					key: 'signType',
					width: 180,
					align: 'center',
          render:(h,params)=>{
						return h('span', {}, params.row.signType === 1 ? '新签' : params.row.signType === 2 ? '续约' : '--')
					}
				},
				{
					title: ' '
        },
        {
					title:'参团时间',
					key: 'createTime',
					width: 180,
					align: 'center',
          render:(h,params)=>{
						return h('span', {}, params.row.createTime ? getDate(params.row.createTime, 'all') : '')
					}
				},
				{
					title: ' '
        },
        {
					title:'截团时间',
					key: 'endTime',
					width: 180,
					align: 'center',
          render:(h,params)=>{
						return h('span', {}, params.row.endTime ? getDate(params.row.endTime, 'all') : '')
					}
				},
				{
					title: ' '
        },
        {
					title:'跟进管家',
					key: 'zoName',
					width: 180,
					align: 'center',
				},
				{
					title: ' '
        },
        {
					title:'取消原因',
					key: 'cancelBy',
					width: 180,
					align: 'center',
          render: (h, params) => {
              if (params.row['cancelBy'] && params.row['cancelBy'].length > 20) {
                return h('Tooltip', {
                  props: {
                    placement: "bottom"
                  }
                }, [
                  h('div', {
                    style: {
                      whiteSpace: 'normal'
                    },
                    slot: 'content',
                  }, params.row.cancelBy),
                  h('div', {
                    style:
                        {'line-height':'25px !important'}
                  },  params.row['cancelBy'].slice(0, 20) + '...')
                ])
              } else {
                return h('div', {}, params.row['cancelBy'])
              }

            }
				},
        {
					title: ' '
				},
        {
					title:'最新操作记录',
					key: 'remark',
					width: 180,
					align: 'center',
				},
				{
					title: ' '
				},
				{
          title:'操作',
          width: 160,
          fixed:'right',
          align: 'center',
          render:(h,params)=>{
            return [
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'collageGroup/confirmOrCancelParticipate'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
                      this.fid = params.row.fid;
                      this.cancelGroup++;
                    })
                  }
                },
                style: {
                  marginRight: '10px',
                  display: params.row.participateStatus != 3 ? 'inline-block' : 'none'
                }
              },'取消拼团'),
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'collageGroup/confirmOrCancelParticipate'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确定拼团',
                      content: '<p>是否确定拼团？</p>',
                      onOk: () => {
                        const params2 = {
													itemFid:params.row['fid'],
													participateStatus:2
                        }
                        confirmOrCancelParticipate(params2)
                        .then( res => {
                          if(res.code === 0){
                            this.$Message.success('确定拼团成功')
                            this.getSearchData();
                          } else{
                            this.$Message.info( '确定拼团失败')
                          }
                        })
                        .catch( () => {
                          this.$Message.info( '确定拼团失败')
                        })
                        // .finally( ()=> {
                        //   this.isShow = false
                        // })
                      }
                    })
                  }
                },
                style: {
                  display: params.row.participateStatus == 1 ? 'inline-block' : 'none'
                }
              },'确定拼团'),
            ]
          }
        },
        {
          title: ' '
        },
			],
			secondaryType:[],
			secondaryYYType:[],
			houseTypes:[],
      projects:[],
      limit:10,
			applyObject:[
				{
					text:'项目',
					value:1,
				},
				{
					text:'房型',
					value:2
				}
			]
		}
	},
	created(){
    // this.search();
	},
	methods:{
//     getDate (timeStamp, startType) {
//     const d = new Date(timeStamp)
//     const year = d.getFullYear()
//     const month = this.getHandledValue(d.getMonth() + 1)
//     const date = this.getHandledValue(d.getDate())
//     const hours = this.getHandledValue(d.getHours())
//     const minutes = this.getHandledValue(d.getMinutes())
//     const second = this.getHandledValue(d.getSeconds())
//     let resStr = ""
//     switch (startType) {
//         case "all":
//             resStr = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + second
//             break
//         case "date":
//             resStr = year + "-" + month + "-" + date
//             break
//         case "time":
//             resStr = hours + ":" + minutes + ":" + second
//             break
//         case "year":
//             resStr = year
//             break
//         case "dateNumber":
//             resStr = year + "" + month + "" + date;
//             break
//     }
//     return resStr
// },
// getHandledValue(num) {
//     return num < 10 ? '0' + num : num
// },
		search(data){
      this.page=1
      this.current=1
      this.searchParams = data;
      this.getSearchData();
    },
    getSearchData(){
      const searchParams = {
				page:this.page,
        limit:this.limit,
        ...this.searchParams
      }
      getCollageGroupList(searchParams)
      .then( res=> {
        this.data = res.data.rows;
        this.total = res.data.total
        // this.data.forEach(ele=>{
        //   ele.projectOrHouseTypeNames = ele.projectOrHouseTypeNames.join(',')
        // })
      })
      .catch(err=>{
        console.log(err)
      })
    },
		changePage(n){
      this.current = n;
      this.page = n;
      this.getSearchData()
    },
	},
  filters:{
    dateTimeFilter (val) {
      console.log(new Date(val).getTime())
      return val === null ? '未知' : getDate(new Date(val).getTime(), 'all')
    },
  }
}
</script>
